export const headers = () => {
  return {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  };
};

export const headersFBT = () => {
  return {
    headers: {
      "Content-Type": "application/json",
      Token:
        "a9504442555dbcefbfe99506fa0cef0d8b8fd58e2fb1908602633e5451b4cc2659aed8b2b70b0a7598aeec77028634229acbd0dc24999160b09c9c2a2703e3ed",
    },
  };
};
